import InspectionDetailsLink from './InspectionDetailsLink';

export default InspectionDetailsLink;
